import React from 'react';


// DEFAULT COMPONENT
const UniModalPresentationalBottomSheetKoglovo = (props) => {
  let is_opened = false;
  if (props.opened === true) {
    is_opened = true;
  }
  let clLarge = '';
  if (props.options && props.options.large === true) {
    clLarge = ' unicompo-modal-bottom-sheet-koglovo__modal-wrapper--large';
  }

  let style = { zIndex: 9999 }; // default z-index: 9999
  if (props.options) {
    const zIndex = props?.options?.zIndex;
    if (zIndex > 0 || zIndex === 0 || zIndex < 0) {
      style.zIndex = zIndex;
    }
  }

  const closeOnOverlayClick = props?.options?.closeOnOverlayClick === true;
  const _onOverlayClick = (e) => {
    if (closeOnOverlayClick !== true) {
      return;
    }
    // Close only when tapping on the overlay itself (outside the wrapper).
    // Check if clicked element is the overlay, not any child element
    const overlay = e.currentTarget;
    const wrapper = overlay.querySelector('.unicompo-modal-bottom-sheet-koglovo__modal-wrapper');
    if (wrapper && !wrapper.contains(e.target) && typeof props.cbClose === 'function') {
      props.cbClose();
    }
  };

  /*
  let cl = "modal-overlay";
  if (modal.animateOut === true) {
    cl += ' animate-close';
  }
  */

  return (
    <div className={"unicompo-modal-bottom-sheet-koglovo" + (is_opened ? " unicompo-modal-bottom-sheet-koglovo--is-opened" : "")} style={style}>
      <div className="unicompo-modal-bottom-sheet-koglovo__overlay unicompo-modal-bottom-sheet-koglovo__overlay--sheet-to-window-enabled" onClick={_onOverlayClick}>
        <div className={"unicompo-modal-bottom-sheet-koglovo__modal-wrapper" + clLarge}>
          <div className={"unicompo-modal-bottom-sheet-koglovo__card"}>
            <div className="unicompo-modal-bottom-sheet-koglovo__card__pan-header bottom-sheet__pan">
              <div className="unicompo-modal-bottom-sheet-koglovo__card__bar bottom-sheet__bar" onClick={(e) => {
                if (typeof props.cbClose === 'function') {
                  props.cbClose();
                }
              }}></div>
              <div className="unicompo-modal-bottom-sheet-koglovo__close" onClick={(e) => {
                if (typeof props.cbClose === 'function') {
                  props.cbClose();
                }
              }}>&times;</div>
            </div>
            <div className="unicompo-modal-bottom-sheet-koglovo__card__body bottom-sheet__content">        {
              is_opened && (props.children)
            }</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniModalPresentationalBottomSheetKoglovo;